/**
 * Constants for the root authenticated tabs layout (`app/app/_layout.tsx`).
 *
 * Lives in `appStyles/` because page-level constants for `app/` screens must
 * not live inside `app/` itself — every file there becomes a route.
 */

/** Top-level route segments whose pages should suppress the root tab bar. */
export const HIDE_TAB_BAR_ROUTES = [
  'tutorial',
  'onboarding',
  'oauth-native-callback',
  'oauth-gmail-callback',
  'privacy-and-data',
  'legal',
  'league-detail',
  'match',
  'rank-ladder', // The Climb is a full-screen takeover; the bar (and the Warmup FAB) would float over it.
  'profile', // Self-profile is a full-screen takeover with its own top bar (specs/profile-page).
] as const;

/** Full-screen sheet over the Picks tab — root tab bar hides while it's open. */
export const WORLDCUP_MATCH_ROUTE_PREFIX = '/worldcup/match/';

/** Nested league detail under `/app/gameResults/league-detail`. */
export const LEAGUE_DETAIL_ROUTE = '/league-detail';

/** Generic per-match route prefix (used to hide the root tab bar). */
export const MATCH_ROUTE_PREFIX = '/match/';

export const INDEX_ROUTE_KEY = 'index';
export const CREATE_ROUTE_KEY = 'create';
